// atm mapper objects
const atmCompetitionEvents = require('./atmmapper/competition');

function CompetitionService(Restangular, atm, AtmLocalService, $state) {
    this._getCompApi = Restangular.one('Competition');
    this._getAllCompApi = Restangular.one('Competitions');
    this._api = Restangular.one('/');
    this.atm = atm;
	this.AtmLocalService = AtmLocalService;
	this._$state = $state;

    this.isFormSubmittedSuccessfully = false;
}

CompetitionService.prototype.getCompetitionDetails = function (comp) {
        return this._getCompApi.get({ Url: comp })
            .then((response) => {
                let ret = response || {};
                // remove Restangular stuff from response
                if (typeof ret.plain === 'function') {
                    ret = ret.plain();
                }

                return ret;
            });
};

CompetitionService.prototype.getAllCompetitionDetails = function (urls) {
    return this._getAllCompApi.get({ Urls: urls });
};

CompetitionService.prototype.submit = function (request) {
	this.atm.push(null, atmCompetitionEvents.submitted);

	return this._api.post('CompetitionEntry', request);
};

CompetitionService.prototype.enterCompetitionByOrderId = function (request) {
    return this._api.post('EnterCompetitionByOrderId', request);
};

CompetitionService.prototype.competitionStart = function () {
    // check if this page was already visited (localStorage)
    const isCompetitionAlreadyVisited = this.AtmLocalService.getState('shop.inspiration.win.page') ? false : true;

    // send an analytics event when the user start a form registration
    this.atm.push(isCompetitionAlreadyVisited, atmCompetitionEvents.start);
};

CompetitionService.prototype.competitionAbandoned = function (lastDirtyField) {
    // check if the form was submitted successfully
    if (!this.isFormSubmittedSuccessfully) {
        // if not then trigger an analytics registerAbandoned event
        this.atm.push(lastDirtyField, atmCompetitionEvents.abandoned);
    }
};

CompetitionService.prototype.getEligibleErrorMessage = function (opt = {}) {
    const {
        statusId,
        disallowRegisteredUser
    } = opt;

    const messageKey = `${statusId}`;
    const bannedExclued = 'This account has been excluded from our online services. Please get in touch with us via email if you have any questions around this exclusion.';

    const errorMessageMap = {
        80: bannedExclued,
        90: bannedExclued
    };

    let ret = errorMessageMap[messageKey] || '';

    if (!ret && disallowRegisteredUser) {
        ret = 'Sorry this offer is for new BWS customers only';
    }

    return ret;
};

module.exports = CompetitionService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/competition-service.js
 **/